import { styled } from '@mui/system';
import {
  CenteredContentContainer,
  FlexColumnContainer,
} from 'src/components/styles';

export const ProductCardWrapper = styled(FlexColumnContainer)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
  textAlign: 'center',
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
}));

export const ProductImage = styled(FlexColumnContainer)(() => ({
  height: '46%',
  backgroundPosition: 'center',
  width: '100%',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  alignItems: 'flex-end',
  justifyItems: 'baseline',
}));

export const DiscountPercentageWrapper = styled(CenteredContentContainer)(
  ({ theme }) => ({
    height: '38%',
    width: '29%',
    borderBottomLeftRadius: 10,
    background: theme.palette.primary.dark,
    color: '#fff',
    fontWeight: 500,
    [`${theme.breakpoints.down('md')}`]: {
      height: '38%',
      width: '28%',
    },
  })
);
